import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=b526f28a&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=b526f28a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b526f28a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b526f28a')) {
      api.createRecord('b526f28a', component.options)
    } else {
      api.reload('b526f28a', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=b526f28a&scoped=true", function () {
      api.rerender('b526f28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Info.vue"
export default component.exports